module.exports = "/_next/static/images/5cee7992da3b45cd70cb993f0199fb99-man-looking-up-smiling-md@1x.jpg";